/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React from 'react';
import PropTypes from 'prop-types';

import ProgressIndicator from '@ba-ui-toolkit/progressindicator';
import { WizardStepIndicator } from './WizardStepIndicator';
import { checkStepSequence, getStepProgress } from './services/step-helpers';
import { STEPS } from './literals/literals';

import styles from './WizardProgressIndicator.scss';

export const WizardProgressIndicator = props => {
	const { steps } = props;
	const sanitizedClassName = styles.wizardProgressIndicatorClassName.replace(/"/g, '');

	checkStepSequence(steps);

	const progress = getStepProgress(steps);

	return (
		<div className={sanitizedClassName} data-tid="wizard-progress-indicator">
			<ProgressIndicator progress={progress} variant="bar" />
			<div data-tid="step-container">
				{props.steps.map((step, index) => (
					<WizardStepIndicator key={index} label={step.label} step={step.step} />
				))}
			</div>
		</div>
	);
};

WizardProgressIndicator.propTypes = {
	steps: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			step: PropTypes.oneOf(STEPS).isRequired,
		})
	),
};
